import UtilsUrl from "../../utils/UtilsUrl";
import api from "./../api";

class ClientService {
  countgenres() {
    return api.get(UtilsUrl.marketingURL() + "/client/countgenre", {
      headers: {
        "Content-Type": "multipart/form-data", // Set the content type to multipart/form-data
      },
    });
  }

  countAges() {
    return api.get(UtilsUrl.marketingURL() + "/client/countage", {
      headers: {
        "Content-Type": "multipart/form-data", // Set the content type to multipart/form-data
      },
    });
  }

  calculateAgePercentageWithGenre() {
    return api.get(UtilsUrl.marketingURL() + "/client/countageAndGenre", {
      headers: {
        "Content-Type": "multipart/form-data", // Set the content type to multipart/form-data
      },
    });
  }

  countPourcentagePays() {
    return api.get(UtilsUrl.marketingURL() + "/client/countPays", {
      headers: {
        "Content-Type": "multipart/form-data", // Set the content type to multipart/form-data
      },
    });
  }

  AfficherListGenres() {
    return api.get(UtilsUrl.marketingURL() + "/EnumList/getGenre");
  }

  AfficherListClients(idUser) {
    return api.get(UtilsUrl.marketingURL() + "/client/getAll/" + idUser);
  }

  ajouterClient(idUser, nouveauClient) {
    return api.post(
      UtilsUrl.marketingURL() + "/client/add/" + idUser,
      nouveauClient
    );
  }

  mettreAJourClient(updatedClient, ClientId) {
    return api.put(
      UtilsUrl.marketingURL() + "/client/update/" + ClientId,
      updatedClient
    );
  }

  supprimerClient(ClientId) {
    return api.put(UtilsUrl.marketingURL() + "/client/delete/" + ClientId, {
      headers: {
        "Content-Type": "multipart/form-data", // Set the content type to multipart/form-data
      },
    });
  }

  ImporterCSV(file) {
    return api.post(UtilsUrl.marketingURL() + "/client/importcsv", file, {
      headers: {
        "Content-Type": "multipart/form-data", // Set the content type to multipart/form-data
      },
    });
  }

  Exportcsv() {
    return api.get(
      UtilsUrl.marketingURL() + "/client/exportcsv",
      {
        responseType: "blob",
      },
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the content type to multipart/form-data
        },
      }
    );
  }

  //filtre
  getClientsByFiltre(nom, startDate, endDate) {
    return api.get(
      UtilsUrl.marketingURL() +
        "/client/filtre?nom=" +
        nom +
        "&startDate=" +
        startDate +
        "&endDate=" +
        endDate
    );
  }
}

export default new ClientService();
